$.extend(Fotobook.book, {
    orderProject: function(){
        if ($("html").hasClass("preview")) {
            Fotobook.commands.togglePreview();
        }
        Fotobook.login.loginIfGuest().then(() => {
            return Fotobook.saveProject(false).then(() => {
                const id = Fotobook.book.project.id;
                Fotobook.cart.checkProjectQuality(id).then(() => {
                    // Проект уже сохранен. Фоновые задачи (загрузка фото, наример) игнорируем
                    Fotobook.beforeUnload.clearStack();
                    //отрабатывает при успехе либо нажатии на кнопку "Игнорировать сообщение"
                    Fotobook.cart.orderProject(id).then(() => {
                        window.location.replace(Fotobook.cart.cartUrl);
                    }).catch(() => {});
                }).catch(async () => {
                    // показываем ошибки
                    await Fotobook.store.dispatch('bottomPanel/setShowBookErrors', true);

                    // пока мы не можем юзать импорты, передаём 1 (что идентично TAB_PAGES)
                    // после переписывания данного модуля на Vue можно будет передать таб как надо
                    // await Fotobook.store.dispatch('bottomTabs/setActiveTab', Fotobook.bottomPanel.TAB_PAGES);
                    await Fotobook.store.dispatch('bottomTabs/setActiveTab', 1);

                    // больше не нужно, переписали на vue через диспатчи
                    // const $bTabs = $("#bottom-tabs"),
                    //     $errorsCheckbox = $('#show-book-errors');
                    //
                    // if (!$errorsCheckbox.is(':checked')) {
                    //     $errorsCheckbox.prop('checked', true);
                    // }
                    // $errorsCheckbox.trigger("change");
                    // if ($bTabs.tabs('option', 'active') === 0) {
                    //     $bTabs.tabs('option', 'active', 1);
                    // }
                });
            });
        }).catch(
            () => {}
        );
    }
});
